import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { LTFilterComponent } from '../lt-filter/lt-filter.component';
import { LTFilter, LTFilterColumn } from '../../models/lt-filter.models';

interface LTFilterDialogData {
  columns: LTFilterColumn[];
  filter?: LTFilter | null;
}

@Component({
  selector: 'app-lt-filter-dialog',
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    LTFilterComponent,
  ],
  templateUrl: './lt-filter-dialog.component.html',
  styleUrl: './lt-filter-dialog.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LTFilterDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<LTFilterDialogComponent>);
  readonly dialogData = inject<LTFilterDialogData>(MAT_DIALOG_DATA);

  applyFilter(filter: LTFilter | null): void {
    this.dialogRef.close(filter);
  }

  close(): void {
    this.dialogRef.close();
  }
}
